module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"home":"Service de téléchargement de fichiers","footerMessage1":"Pour personnaliser ce service aux couleurs de votre entreprise, contactez-nous au ","footerMessage2":"ou par courriel : "},"en":{"home":"Files download service","footerMessage1":"To customize the service to your company colors, contact us at ","footerMessage2":"or email: "}}')
  delete Component.options._Ctor
}
